import { api } from '@/lib/api';
import type { MeshNode } from './types';

/** @param refresh bypass the backend's Headscale success and failure caches */
export async function getMeshNodes(refresh = false): Promise<MeshNode[]> {
  const response = await api.get<{ nodes: MeshNode[] }>('/v4/tailscale/nodes', refresh ? { refresh } : undefined);
  return response.nodes || [];
}
